import {
  ADDNEWFIELD_DIALOG_OPEN,
  ADDNEWFIELD_DIALOG_CLOSE
} from "types/actions/add-new-field-dialog"

export const openAddNewFieldDialog = field => {
  return {
    type: ADDNEWFIELD_DIALOG_OPEN,
    open: true,
    field
  }
}

export const closeAddNewFieldDialog = field => ({
  type: ADDNEWFIELD_DIALOG_CLOSE,
  open: false,
  field
})



// WEBPACK FOOTER //
// ./src/actions/add-new-field-dialog.js